<template>
    <div class="zoom-controls">
        <button
            id="zoom-in-btn"
            type="button"
            class="zoom-btn"
            aria-label="Zoom in"
            @click="handleZoomIn"
            @keydown="handleKeyDown"
            :disabled="disabled"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.9999 21L16.6499 16.65"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M11 8V14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M8 11H14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <al-tooltip
                text="Zoom in"
                for="#zoom-in-btn"
            />
        </button>
        
        <button
            id="zoom-out-btn"
            type="button"
            class="zoom-btn"
            aria-label="Zoom out"
            @click="handleZoomOut"
            @keydown="handleKeyDown"
            :disabled="disabled"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M20.9999 21L16.6499 16.65"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M8 11H14"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <al-tooltip
                text="Zoom out"
                for="#zoom-out-btn"
            />
        </button>
        
        <button
            id="reset-to-fit-btn"
            type="button"
            class="zoom-btn"
            aria-label="Reset to fit"
            @click="handleResetToFit"
            @keydown="handleKeyDown"
            :disabled="disabled"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <!-- eslint-disable max-len -->
                <path
                    d="M10.6406 2.55469C10.8281 2.35156 11.0625 2.24219 11.3438 2.22656C11.625 2.21094 11.8672 2.29688 12.0703 2.48438L13.8047 4.10156C13.9141 4.17969 13.9922 4.28125 14.0391 4.40625C14.1016 4.53125 14.1328 4.66406 14.1328 4.80469C14.1328 4.94531 14.1094 5.07812 14.0625 5.20312C14.0156 5.32813 13.9453 5.4375 13.8516 5.53125L12.0938 7.28906C11.8906 7.47656 11.6484 7.57031 11.3672 7.57031C11.1016 7.57031 10.8672 7.46875 10.6641 7.26562C10.5078 7.09375 10.4141 6.89062 10.3828 6.65625C10.3672 6.42188 10.4219 6.21094 10.5469 6.02344C9.84375 6.16406 9.21875 6.375 8.67188 6.65625C8.125 6.9375 7.65625 7.26562 7.26562 7.64062C6.73438 8.14062 6.32812 8.71875 6.04688 9.375C5.76562 10.0312 5.625 10.7344 5.625 11.4844C5.625 12.2969 5.69531 12.9609 5.83594 13.4766C5.99219 13.9766 6.17969 14.3984 6.39844 14.7422C6.61719 15.0859 6.89062 15.3984 7.21875 15.6797C7.54688 15.9609 7.9375 16.2656 8.39062 16.5938C8.60938 16.7656 8.74219 16.9922 8.78906 17.2734C8.83594 17.5391 8.77344 17.7812 8.60156 18C8.44531 18.2188 8.22656 18.3516 7.94531 18.3984C7.67969 18.4453 7.4375 18.3828 7.21875 18.2109C6.78125 17.8984 6.33594 17.5547 5.88281 17.1797C5.44531 16.8047 5.05469 16.3516 4.71094 15.8203C4.36719 15.2734 4.10156 14.6562 3.91406 13.9688C3.72656 13.2656 3.63281 12.4375 3.63281 11.4844C3.63281 10.4844 3.82031 9.52344 4.19531 8.60156C4.58594 7.67969 5.14844 6.86719 5.88281 6.16406C6.49219 5.60156 7.19531 5.13281 7.99219 4.75781C8.80469 4.38281 9.71094 4.11719 10.7109 3.96094C10.5078 3.77344 10.3984 3.54688 10.3828 3.28125C10.3672 3 10.4531 2.75781 10.6406 2.55469Z"
                    fill="currentColor"
                />
                <path
                    d="M16.0078 5.97656C16.1641 5.75781 16.375 5.625 16.6406 5.57812C16.9219 5.53125 17.1719 5.59375 17.3906 5.76562C18.4375 6.51562 19.1953 7.42969 19.6641 8.50781C20.1484 9.57031 20.3906 10.7578 20.3906 12.0703C20.3906 13.0078 20.2266 13.9062 19.8984 14.7656C19.5703 15.6406 19.1094 16.4375 18.5156 17.1562C17.9219 17.8594 17.2266 18.4609 16.4297 18.9609C15.6172 19.4609 14.7344 19.8047 13.7812 19.9922L13.8516 20.0391C14.0391 20.2266 14.1328 20.4609 14.1328 20.7422C14.1328 21.0234 14.0391 21.2578 13.8516 21.4453C13.6484 21.6484 13.4062 21.75 13.125 21.75C12.8594 21.75 12.625 21.6484 12.4219 21.4453L10.7578 19.7812C10.5703 19.5938 10.4766 19.3594 10.4766 19.0781C10.4766 18.7969 10.5703 18.5625 10.7578 18.375L12.4219 16.7109C12.625 16.5078 12.8594 16.4062 13.125 16.4062C13.4062 16.4062 13.6484 16.5078 13.8516 16.7109C14.0078 16.8672 14.1016 17.0547 14.1328 17.2734C14.1641 17.4766 14.1328 17.6719 14.0391 17.8594C14.6641 17.6562 15.2422 17.3594 15.7734 16.9688C16.3203 16.5938 16.7812 16.1484 17.1562 15.6328C17.5469 15.1172 17.8516 14.5547 18.0703 13.9453C18.2891 13.3359 18.3984 12.7109 18.3984 12.0703C18.3984 11.0234 18.2188 10.1172 17.8594 9.35156C17.5 8.57031 16.9531 7.91406 16.2188 7.38281C16 7.21094 15.8672 6.99219 15.8203 6.72656C15.7734 6.44531 15.8359 6.19531 16.0078 5.97656Z"
                    fill="currentColor"
                />
                <!-- eslint-enable max-len -->
            </svg>
            <al-tooltip
                text="Reset to fit"
                for="#reset-to-fit-btn"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
import '@playvox/almendra/dist/components/tooltip';

interface Props {
    disabled?: boolean;
}

withDefaults(defineProps<Props>(), { disabled: false });

const emit = defineEmits<{
    'zoom-in': [];
    'zoom-out': [];
    'reset-to-fit': [];
}>();

const handleZoomIn = () => {
    emit('zoom-in');
};

const handleZoomOut = () => {
    emit('zoom-out');
};

const handleResetToFit = () => {
    emit('reset-to-fit');
};

// Prevent default Space key behavior that can cause tooltip positioning issues
const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        // Trigger the button click programmatically
        (event.target as HTMLButtonElement)?.click();
    }
};
</script>

<style>
/* Global styles for Almendra tooltips - must be unscoped to pierce shadow DOM */

/* CSS Custom Properties for Almendra Web Components */
al-tooltip {
    --al-tooltip-background-color: #000000;
    --al-tooltip-color: #FFFFFF;
    --al-tooltip-opacity: 1;
    --tooltip-background-color: #000000;
    --tooltip-color: #FFFFFF;
    --tooltip-opacity: 1;
}

/* Direct targeting of tooltip elements */
al-tooltip,
al-tooltip *,
.al-tooltip,
.al-tooltip *,
[role="tooltip"],
[role="tooltip"] * {
    background-color: #000000 !important;
    color: #FFFFFF !important;
    opacity: 1 !important;
}

/* Shadow DOM parts - all possible variations */
al-tooltip::part(base),
al-tooltip::part(popup),
al-tooltip::part(tooltip),
al-tooltip::part(content),
al-tooltip::part(arrow) {
    background-color: #000000 !important;
    color: #FFFFFF !important;
    opacity: 1 !important;
}

/* Tippy.js (commonly used by web component libraries) */
.tippy-box,
.tippy-box[data-theme~='dark'],
.tippy-content {
    background-color: #000000 !important;
    color: #FFFFFF !important;
    opacity: 1 !important;
}

.tippy-arrow {
    color: #000000 !important;
}
</style>

<style scoped>
.zoom-controls {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 10px;
    gap: 12px;
    width: 116px;
    height: 38px;
    /* WFM/WFMBlue/50 (Default) */
    border: 1px solid #31708F;
    border-radius: 4px;
    background: #FFFFFF;
    margin-left: 25px; /* Space from Group By button */
}

.zoom-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    /* Smooth transitions for all interactive states */
    transition: all 0.2s ease;
    /* Text/80 */
    color: #1A2021;
    flex: none;
    flex-grow: 0;
    position: relative;
}

.zoom-btn svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    /* Smooth icon transition */
    transition: transform 0.2s ease;
}

/* Hover state - subtle background with icon scale */
.zoom-btn:hover:not(:disabled) {
    background-color: #E8F4F8;
    color: #31708F;
}

.zoom-btn:hover:not(:disabled) svg {
    transform: scale(1.1);
}

/* Active/Click state - darker background without transform to prevent tooltip repositioning */
.zoom-btn:active:not(:disabled) {
    background-color: #D1E7F0;
    color: #31708F;
    /* Removed transform: scale(0.95) to prevent tooltip positioning issues */
}

.zoom-btn:active:not(:disabled) svg {
    transform: scale(1.05);
}

/* Disabled state */
.zoom-btn:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    color: #A0A0A0;
}

/* Only show outline on keyboard focus, not mouse click */
.zoom-btn:focus {
    outline: none;
}

.zoom-btn:focus-visible {
    outline: 2px solid #31708F;
    outline-offset: 2px;
    background-color: #E8F4F8;
}

/* Ripple effect for better click feedback */
@keyframes ripple {
    0% {
        transform: scale(0);
        opacity: 0.6;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

.zoom-btn::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #31708F;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    pointer-events: none;
}

.zoom-btn:active:not(:disabled)::after {
    animation: ripple 0.4s ease-out;
}
</style>
